import { Component, Input, OnInit } from '@angular/core';
import { MailAttachment } from '../../interfaces/mail-attachment.interface';
import { NgIf } from '@angular/common';
import { MailService } from '../../services/mail.service';

@Component({
    selector: 'vex-mail-attachment',
    templateUrl: './mail-attachment.component.html',
    styleUrls: ['./mail-attachment.component.scss'],
    imports: [NgIf]
})
export class MailAttachmentComponent implements OnInit {
  @Input({ required: true }) attachment!: MailAttachment;

  constructor(private mailService: MailService) {}

  ngOnInit(): void {}

  isImage() {
    return (
      this.attachment?.type === 'png' ||
      this.attachment?.type === 'jpg' ||
      this.attachment?.type === 'gif' ||
      this.attachment?.type === 'jpe'
    );
  }

  download() {
    if (this.attachment.id) {
      this.mailService.downloadAttachment(this.attachment.id, this.attachment.filename || this.attachment.label);
    }
  }
}
